import { useDispatch, useSelector } from 'react-redux';
import EmbryologySummary from './Components/EmbryologySummary';
import EmbryologyBiopsy from './Components/EmbryologyBiopsy';
import {
  checkFileAvailabilityApi,
  getPatientDetailsApi,
} from '../../../api/patientApi';
import { useState } from 'react';
import {
  generateOocyteEmbryoReport,
  generateSummaryReport,
  saveAndGenerateOPUReport,
  saveEmbryologyBiopsyData,
  saveEmbryologyCryopreservation,
  saveEmbryologyFreezingInventory,
  saveEmbryologyFrozenTransferData,
  saveEmbryologyOocyteEmbryoRecord,
  saveEmbryologySummaryData,
  saveEmbryologyTransferData,
  updateFetCycle,
} from '../../../api/embryologyApi';
import { toast } from 'sonner';
import { downloadFile, pollFileAvailability } from '../../../api/utils';
import { setEmbryologyData } from '../../../actions/embryologyActions';
import EmbryologyOocyteEmbryoRecord from './Components/EmbryologyOocyteEmbryoRecord';
import EmbryoCryopreservation from './Components/EmbryoCryopreservation';
import EmbryologySummaryReport from './Components/EmbryologySummaryReport';
import EmbryologyTransferDetails from './Components/EmbryologyTransferDetails';
import EmbryologyFrozenTransferDetails from './Components/EmbryologyFrozenTransferDetails';
import {
  initialFrozenTransferState,
  initialState,
} from '../../../reducers/embryologyReducer';
import { Grid } from '@mui/material';
import EmbryologyFreezingInventory from './Components/EmbryologyFreezingInventory';

const EmbryologyForms = ({
  currentForm,
  setCurrentForm,
  selectedCycle,
  setSelectedCycle,
  patientDataHandler,
  selectedFetCycle,
  setSelectedFetCycle,
  tiles,
  handleCompleteFETCycle, // Add this prop
}) => {
  const [loading, setLoading] = useState(false);
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);
  const patientData = useSelector((state) => state.embryologyReducer);
  const dispatch = useDispatch();

  const checkIfFormsDisabled = () => {
    if (!selectedCycle.active) {
      return true;
    }
    return false;
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      if (currentForm === 1) {
        const result = await saveEmbryologySummaryData(
          patientData.selectedPatientData.patient.id,
          patientData.summary,
          selectedCycle.id,
        );

        dispatch(setEmbryologyData(`summary.id`, result.data.result.id));
      } else if (currentForm === 2) {
        const result = await saveEmbryologyBiopsyData(
          patientData.selectedPatientData.patient.id,
          patientData.biopsy,
          selectedCycle.id,
        );

        dispatch(setEmbryologyData(`biopsy.id`, result.data.result.id));
      } else if (currentForm === 4) {
        const result = await saveEmbryologyOocyteEmbryoRecord(
          patientData.selectedPatientData.patient.id,
          patientData.oocyteEmbryo,
          selectedCycle.id,
        );

        dispatch(setEmbryologyData(`oocyteEmbryo.id`, result.data.result.id));
      } else if (currentForm === 3) {
        const result = await saveEmbryologyTransferData(
          patientData.selectedPatientData.patient.id,
          patientData.embryoTransferDetails,
          selectedCycle.id,
        );

        dispatch(
          setEmbryologyData(`embryoTransferDetails.id`, result.data.result.id),
        );
      } else if (currentForm === 5) {
        const result = await saveEmbryologyCryopreservation(
          patientData.selectedPatientData.patient.id,
          patientData.cryopreservation,
          selectedCycle.id,
        );
        dispatch(
          setEmbryologyData(`cryopreservation.id`, result.data.result.id),
        );
      } else if (currentForm === 6) {
        const result = await updateFetCycle(
          patientData.selectedPatientData.patient.id,
          selectedFetCycle.id,
          patientData.embryoFrozenTransferDetails,
        );

        dispatch(
          setEmbryologyData(
            `embryoFrozenTransferDetails.id`,
            result.data.result.id,
          ),
        );
      } else if (currentForm === 7) {
        await handleReportDownload();
      } else if (currentForm === 8) {
        const result = await saveEmbryologyFreezingInventory(
          patientData.selectedPatientData.patient.id,
          patientData.freezingInventory,
        );
        dispatch(
          setEmbryologyData(`freezingInventory.id`, result.data.result.id),
        );
        toast.success('Data saved');
      }

      toast.success('Data saved');
      setLoading(false);
    } catch (error) {
      console.error('Error saving data:', error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      }
      setLoading(false);
    }
  };

  const getDownloadButtonState = () => {
    if (currentForm === 1 && patientData.summaryId) {
      return false;
    }

    if (currentForm === 4 && patientData.oocyteEmbryo.id) {
      return false;
    }
    return true;
  };

  const handleReportDownload = async () => {
    try {
      setIsDownloadDisabled(true);
      let res;
      if (currentForm === 1) {
        res = await generateSummaryReport(
          patientData.selectedPatientData.patient.id,
          patientData.summaryId,
        );
      } else if (currentForm === 4) {
        res = await generateOocyteEmbryoReport(
          patientData.selectedPatientData.patient.id,
          patientData.oocyteEmbryo.id,
        );
      } else if (currentForm === 7) {
        res = await saveAndGenerateOPUReport(
          patientData.selectedPatientData.patient.id,
          patientData.summaryReport,
          selectedCycle.id,
        );
      }

      if (res.data.result && res.data.result.file) {
        setIsDownloadDisabled(false);
        toast.success('Generated report');

        try {
          const presignedUrl = await pollFileAvailability(
            checkFileAvailabilityApi,
            res.data.result.file.bucketName,
            res.data.result.file.fileKey,
          );
          dispatch(
            setEmbryologyData('summary.reportId', res.data.result.file.id),
          );
          downloadFile(
            presignedUrl,
            patientData.selectedPatientData.patient.id,
          );
          toast.success('Report is downloaded successfully');
        } catch (error) {
          setIsDownloadDisabled(false);
          console.error('Failed to get presigned URL:', error);
        } finally {
          setIsDownloadDisabled(false);
        }
      }
    } catch (error) {
      setIsDownloadDisabled(false);
      toast.error('Error generating report:', error);
    }
  };
  return (
    <>
      <div
        className="flex"
        style={{
          alignItems: 'flex-start',
          position: 'sticky',
          zIndex: 1,
          background: '#ffff',
          padding: '5px',
        }}
      >
        <div className="container-fluid" style={{ flex: '1 0 0' }}>
          <button
            style={{ marginTop: 20 }}
            className="btn btn-primary"
            onClick={async () => {
              if (patientData.selectedPatientData?.patient?.id) {
                // dispatch(resetPatientData());
                const res = await getPatientDetailsApi(
                  patientData.selectedPatientData.patient.id,
                );
                patientDataHandler(res.data);
              }
              setCurrentForm(0);
              setSelectedCycle({
                id: null,
                active: false,
              });
            }}
          >
            Back
          </button>
        </div>
        <div
          style={{
            textAlign: 'center',
            marginTop: '20px',
            marginRight: '20px',
          }}
        >
          <button
            className="btn btn-primary"
            onClick={handleSave}
            style={{ marginLeft: '10px' }}
            disabled={loading || checkIfFormsDisabled()}
          >
            {currentForm === 7 ? 'Generate Report' : 'Save'}
          </button>
          <button
            onClick={() => setCurrentForm(0)}
            style={{ marginLeft: '10px' }}
            className="btn btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
      {currentForm === 1 && (
        <EmbryologySummary
          cycleId={selectedCycle.id}
          isDisabled={checkIfFormsDisabled()}
        />
      )}
      {currentForm === 2 && (
        <EmbryologyBiopsy
          cycleId={selectedCycle.id}
          isDisabled={checkIfFormsDisabled()}
        />
      )}
      {currentForm === 3 && (
        <EmbryologyTransferDetails
          cycleId={selectedCycle.id}
          isDisabled={checkIfFormsDisabled()}
        />
      )}
      {currentForm === 4 && (
        <EmbryologyOocyteEmbryoRecord
          cycleId={selectedCycle.id}
          isDisabled={checkIfFormsDisabled()}
        />
      )}
      {currentForm === 5 && (
        <EmbryoCryopreservation
          cycleId={selectedCycle.id}
          isDisabled={checkIfFormsDisabled()}
        />
      )}
      {currentForm === 6 && (
        <EmbryologyFrozenTransferDetails
          selectedFetCycle={selectedFetCycle}
          handleCompleteFETCycle={handleCompleteFETCycle} // Pass the method as a prop
        />
      )}
      {currentForm === 7 && (
        <EmbryologySummaryReport
          cycleId={selectedCycle.id}
          isDisabled={checkIfFormsDisabled()}
        />
      )}
      {currentForm === 8 && <EmbryologyFreezingInventory />}
      {/* {currentForm === 7 && (
      {/* {currentForm === 6 && <FrozenEmbryoTransferSheet />}
    {currentForm === 7 && <PregnancyDetails />} */}
      {/* {currentForm !== 2 && (
        <div
          style={{
            display: 'flex',
            gap: '4px',
            alignItems: 'center',
          }}
        >
          <button
            style={{ marginTop: 20 }}
            className="btn btn-primary"
            onClick={handleReportDownload}
            disabled={getDownloadButtonState() || isDownloadDisabled}
          >
            Download Report
          </button>
        </div>
      )} */}
      {currentForm !== 6 && (
        <div className="mt-4">
          <Grid container spacing={2}>
            {tiles.map((tile, index) => (
              <Grid item xs={6} md={3} key={index}>
                <button
                  className="btn btn-primary"
                  disabled={currentForm === tile.formId}
                  style={{ width: '200px', height: '70px', marginLeft: '10px' }}
                  onClick={() => {
                    setCurrentForm(tile.formId);
                  }}
                >
                  {tile.title}
                </button>
              </Grid>
            ))}
          </Grid>
        </div>
      )}
      <div
        className="flex"
        style={{
          alignItems: 'flex-start',
          position: 'sticky',
          zIndex: 1,
          background: '#ffff',
          padding: '5px',
        }}
      >
        <div className="container-fluid" style={{ flex: '1 0 0' }}>
          <button
            style={{ marginTop: 20 }}
            className="btn btn-primary"
            onClick={async () => {
              if (patientData.selectedPatientData?.patient?.id) {
                // dispatch(resetPatientData());
                const res = await getPatientDetailsApi(
                  patientData.selectedPatientData.patient.id,
                );
                patientDataHandler(res.data);
              }
              setCurrentForm(0);
            }}
          >
            Back
          </button>
        </div>

        <div
          style={{
            textAlign: 'center',
            marginTop: '20px',
            marginRight: '20px',
          }}
        >
          <button
            className="btn btn-primary"
            onClick={handleSave}
            style={{ marginLeft: '10px' }}
            disabled={loading}
          >
            {currentForm === 7 ? 'Generate Report' : 'Save'}
          </button>
          <button
            onClick={() => setCurrentForm(0)}
            style={{ marginLeft: '10px' }}
            className="btn btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default EmbryologyForms;
